// src/pages/shared/findMe.js
// "When and where do I play?": one player's games, from the rounds the share link shows.
const nameOf = (player) => `${player.firstName} ${player.lastName}`.trim();
const namesOf = (team) => (team?.players || []).map(nameOf);
const hasPlayer = (team, playerId) => (team?.players || []).some((player) => player.playerId === playerId);

// Every round, oldest first, with what that player does in it:
//   { round (number, from 1), roundId, status: 'plays' | 'sits-out' | 'absent',
//     court, partners, opponents, isSingles, cancelled, sets: [[mine, theirs]], result: 'won' | 'lost' | 'draw' | null }
export function gamesOf(rounds, playerId, courts) {
    return [...rounds]
        .sort((a, b) => a.roundId - b.roundId)
        .map((round, index) => {
            const base = { round: index + 1, roundId: round.roundId };
            const position = round.matchups.findIndex((matchup) => hasPlayer(matchup.team1, playerId) || hasPlayer(matchup.team2, playerId));
            if (position === -1) {
                const sitting = (round.idlePlayers || []).some((player) => player.playerId === playerId);
                return { ...base, status: sitting ? 'sits-out' : 'absent' };
            }
            const matchup = round.matchups[position];
            const onTeam1 = hasPlayer(matchup.team1, playerId);
            const mine = onTeam1 ? matchup.team1 : matchup.team2;
            const theirs = onTeam1 ? matchup.team2 : matchup.team1;
            const sets = [];
            let won = 0;
            let lost = 0;
            (matchup.matches || []).forEach((match) => {
                (match.sets || []).forEach((set) => {
                    if (set.team1Score + set.team2Score === 0) return; // not played yet
                    const [a, b] = onTeam1 ? [set.team1Score, set.team2Score] : [set.team2Score, set.team1Score];
                    sets.push([a, b]);
                    if (a > b) won += 1;
                    else if (b > a) lost += 1;
                });
            });
            return {
                ...base,
                status: 'plays',
                court: courts ? position + 1 : null,
                partners: namesOf(mine).filter((name) => name !== nameOf(mine.players.find((p) => p.playerId === playerId))),
                opponents: namesOf(theirs),
                isSingles: Boolean(matchup.isSingles),
                cancelled: Boolean(matchup.cancelled),
                sets,
                result: sets.length === 0 ? null : won > lost ? 'won' : lost > won ? 'lost' : 'draw',
            };
        });
}

// The latest round's entry: that is where and with whom they play now (or next).
export const currentGame = (games) => (games.length ? games[games.length - 1] : null);

const KEY = (token) => `tournamental.me.${token}`;

export function rememberedPlayer(token) {
    try {
        const value = window.localStorage.getItem(KEY(token));
        return value === null ? null : Number(value);
    } catch (error) {
        return null;
    }
}

export function rememberPlayer(token, playerId) {
    try {
        if (playerId === null) window.localStorage.removeItem(KEY(token));
        else window.localStorage.setItem(KEY(token), String(playerId));
    } catch (error) {
        // not remembered
    }
}
